import authenticate from "@/auth/authenticate";

export default [
  {
    path: "/staff",
    component: () =>
      import(/* webpackChunkName: "staff" */ "@/views/global/Index"),

    children: [
      {
        path: "",
        name: "stuff.index",
        redirect: "/app/ticket",
      },
      {
        path: "scanner",
        name: "staff.scanner",
        meta: { layout: "Blank" },
        component: () =>
          import(
            /* webpackChunkName: "staff.scanner" */ "@/views/staff/scanner/ScannerInit"
          ),
      },
      {
        path: "scanner/:session",
        name: "staff.scanner.session",
        meta: { layout: "Blank" },
        component: () =>
          import(
            /* webpackChunkName: "staff.scanner" */ "@/views/staff/scanner/ScannerSession"
          ),
      },
      {
        path: "entrance-report/:token",
        name: "staff.entrance-report",
        meta: { layout: "Blank" },
        component: () =>
          import(
            /* webpackChunkName: "staff.entrance-report" */ "@/views/staff/entrance-report/EntranceReport"
          ),
      },
      {
        path: "courtesy/:partyId",
        name: "staff.courtesyEmitter.party",
        meta: { layout: "Blank" },
        beforeEnter: authenticate,

        component: () =>
          import(
            /* webpackChunkName: "staff" */ "@/views/staff/CourtesyEmitterResponsible.vue"
          ),
      },
      {
        path: "virtual-pos/:code",
        name: "staff.virtualPos.party",
        meta: { layout: "Blank" },
        component: () =>
          import(
            /* webpackChunkName: "staff" */ "@/views/staff/VirtualPos.vue"
          ),
      },
      {
        path: "*",
        redirect: "/app",
      },
    ],
  },
];
